import React, { useEffect } from "react"

import { useNavigationContext } from "shared/context/navigation/NavigationContext"
import { LOGIN_OVERLAY } from "shared/context/overlay/types"
import { useAuth } from "shared/lib/useAuth"
import { useOverlay } from "shared/lib/useOverlay"

export const ProtectedRoute = React.memo(
  ({ children }: { children: React.ReactNode }) => {
    const { isAuthenticated, isLoading } = useAuth()
    const { openOverlay, isOpen } = useOverlay(LOGIN_OVERLAY)

    const { back } = useNavigationContext()
    const shouldOpen = !isAuthenticated && !isLoading && !isOpen

    useEffect(() => {
      if (shouldOpen && !isOpen) {
        openOverlay(null, {
          onClose: back
        })
      }
    }, [shouldOpen, isOpen])

    if (!isAuthenticated || isLoading) {
      return null
    }

    return children as React.JSX.Element
  }
)
